module.exports = __webpack_public_path__ + "static/img/1-2.38675d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/1-2.png
// module id = +Wvp
// module chunks = 0